
import sdLink from '@smartdesign/vue/components/link';

export default {
  name: 'DataProtectionSection',
  components: {
    sdLink,
  },
};
